import { LayoutFooter } from '@fhs/page-builder';

import { useActionHandler } from './use-action-handler';
import { useLoyaltyHomepageConfigQuery } from './use-loyalty-homepage-config-query';

export function LoyaltyHomepageFooter() {
  const { data: loyaltyHomepageConfigDocument } = useLoyaltyHomepageConfigQuery();
  const footer = loyaltyHomepageConfigDocument?.unauthenticatedUsers?.layout?.footer;

  const handleAction = useActionHandler();

  if (!footer) {
    return null;
  }

  return (
    <LayoutFooter
      legalLinks={footer.legalLinks}
      legalText={footer.legalText}
      linkGroups={footer.linkGroups}
      socialLinks={footer.socialLinks}
      onAction={handleAction}
    />
  );
}
